import { defineStore } from 'pinia';
import { lumenApi, getToken, setToken, removeToken } from '@/libs/axiosConfig';

export const useAuthStore = defineStore("auth", {
  state: () => ({
    currentUser: JSON.parse(localStorage.getItem('authUser')) || null, // Lấy thông tin người dùng từ sessionStorage
    accessToken: getToken() || null, // Lấy accessToken từ sessionStorage
  }),

  getters: {
    loggedIn() {
      // Kiểm tra xem currentUser và accessToken có tồn tại hay không
      return !!this.currentUser && !!getToken();
    }
  },

  actions: {
    async logIn({ email, password }) {
      try {
        // Gọi API đăng nhập
        const response = await lumenApi.post('/auth/login', { email, password });

        if (response.data && response.data.success) {
          const { accessToken, privileged } = response.data.data;

          // Cập nhật state và sessionStorage
          this.setUser(privileged);
          setToken(accessToken);

          return { success: true, user: privileged, token: accessToken };
        } else {
          return { success: false, message: "Đăng nhập thất bại. Vui lòng kiểm tra lại email và mật khẩu." };
        }
      } catch (error) {
        console.error("Login error:", error);
        return { success: false, message: error.response?.data?.message || error.message };
      }
    },

    setUser(user) {
      // Cập nhật state `currentUser` và lưu vào sessionStorage
      this.currentUser = user;
      localStorage.setItem('authUser', JSON.stringify(user)); // Lưu currentUser vào sessionStorage để duy trì trạng thái
      localStorage.setItem('lastEmail', user.email);
    },

    logOut() {
      // Xóa state và sessionStorage khi đăng xuất
      this.currentUser = null;
      localStorage.removeItem('authUser');
      removeToken()
    },

    validate() {
      // Kiểm tra xem người dùng có hợp lệ không
      return this.currentUser && this.accessToken ? true : false;
    }
  },
});
